import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/carte-confituur-grafisch-ontwerp-yasmine-ontwerpbureau-nazareth-de-pinte.png'


const _withScopeId = n => (_pushScopeId("data-v-51b86b44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Carte Confituur | Over", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://www.carteconfituur.be/info"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Kom meer te weten over Carte Confituur en hoe we werken."
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "Carte Confituur | Over"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://www.carteconfituur.be/info"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Kom meer te weten over Carte Confituur en hoe we werken."
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "article"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:title",
  content: "Carte Confituur | Over"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:description",
  content: "Kom meer te weten over Carte Confituur en hoe we werken."
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "aboutBlocks" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "aboutBlock left" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "aboutImage" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "imageWrapper" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_0,
            alt: "hallo!"
          })
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "aboutBlock right" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
        /*#__PURE__*/_createTextVNode(" THE DESIGNER "),
        /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, "behind Carte Confituur")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Hello!"),
        /*#__PURE__*/_createElementVNode("span", null, "Ik ben Yasmine en het trotse gezicht achter Carte Confituur."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", null, "Deze one-woman-business kwam er vanuit mijn liefde voor knappe vormgeving. Ik help jou graag verder met het creatief vertalen van jouw eigen verhaal. Van geboortekaartjes, originele huwelijksuitnodigingen, catchy (re)branding,... Steeds gaan we samen voor dat tikkeltje extra en een resultaat waar jij volledig achter staat.")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "title contactTitle" }, " CONTACT "),
      /*#__PURE__*/_createElementVNode("div", { class: "contact" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Nu je een idee hebt gekregen van mijn verhaal, ben ik heel erg benieuwd naar dat van jou."),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("Stuur me gerust een mailtje naar "),
          /*#__PURE__*/_createElementVNode("a", { href: "mailto:hallo@carteconfituur.be" }, "hallo@carteconfituur.be"),
          /*#__PURE__*/_createTextVNode(" en dan maken we er samen iets moois van!")
        ]),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createTextVNode("Of volg Carte Confituur via "),
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://www.instagram.com/carteconfituur.be/",
            target: "_blank"
          }, "Instagram"),
          /*#__PURE__*/_createTextVNode(" voor de laatste realisaties en een blik achter de schermen.")
        ])
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_1
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_2
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_3
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_4
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_5
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_6
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_7
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_8
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_9
    ])),
    _hoisted_10
  ], 64))
}